import { render, staticRenderFns } from "./HighlightsAwards.vue?vue&type=template&id=73e52f4e&scoped=true"
import script from "./HighlightsAwards.vue?vue&type=script&lang=ts"
export * from "./HighlightsAwards.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsAwards.vue?vue&type=style&index=0&id=73e52f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e52f4e",
  null
  
)

export default component.exports